import styled from "styled-components";

export const SearchSaveFiltersSubHeaderWrapper = styled.div`
  .responsive-search-btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
  }

  .form-header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .MuiButton-root {
      height: auto;
      padding-left: 4px;

      svg {
        margin-right: 10px;
      }
    }
  }

  .form-header-right.with-extra-actions {
    padding: 0px 16px 16px 16px;
    .MuiButton-root {
      height: auto;
      padding-left: 14px;
      padding-left: 14px;

      svg {
        margin-right: 10px;
      }
    }
  }

  .reset-all-button {
    min-width: 48px;
    min-height: 48px;
    margin-right: 16px;
  }
`;
